{
  "venueEdit": {
    "insertFailure": "Impossible de créer le lieu",
    "editFailure": "Impossible de modifier le lieu",
    "deleteFailure": "Impossible de supprimer le lieu",
    "creationSuccess": "Lieu créé avec succès",
    "editSuccess": "Le lieu a été changé avec succès",
    "deleteSuccess": "Lieu supprimé avec succès",
    "topLevel": "Niveau supérieur"
  },
  "resetZoom": "Réinitialiser le zoom",
  "shareOrExport": {
    "title": "Calendrier de partage/exportation",
    "shareLinkOptionTitle": "Partager le lien",
    "shareLinkOptionDescription": "Partager le calendrier sélectionné par un lien en lecture seule (expiration 7 jours)",
    "exportOptionTitle": "Calendrier d'exportation",
    "exportOptionDescription": "Exporter le calendrier sélectionné",
    "shareLinkLabel": "Lien",
    "exportStarted": "L'exportation a commencé",
    "pickOption": "Sélectionnez une option"
  },
  "eventBlocksImport": "L'importation s'est terminée avec succès",
  "shareSchedule": "Le lien du calendrier partagé a été copié dans votre presse-papiers",
  "visitSchedule": "Calendrier des visites"
}